(() => {
  'use strict';

  /**
   * HomeSilky Compatibility Checker
   * Part 1
   */

  const initializedSections = new WeakSet();

  function initSection(section) {

    if (!section) return;
    if (initializedSections.has(section)) return;

    initializedSections.add(section);

    const config = window.HomeSilkyCompatibility?.[section.id];

    if (!config) {
      console.warn('HomeSilky Compatibility config not found:', section.id);
      return;
    }

    const state = {
      skin: null,
      hair: null
    };

    
    const result = section.querySelector('.hs-checker__result');

    const display = section.querySelector('.hs-checker__display');

    const resultIcon = section.querySelector('.hs-checker__result-icon');

    const resultTitle = section.querySelector('.hs-checker__result-title');

    const resultText = section.querySelector('.hs-checker__result-text');

    const retryBtn = section.querySelector('.hs-checker__retry');

    const optionButtons = section.querySelectorAll('.hs-checker__option');

    optionButtons.forEach(button => {

      button.addEventListener('click', () => {

        const group = button.dataset.group;
        const value = button.dataset.value;

        state[group] = value;

        updateSelection(group, value);

        evaluate();

      });

    });

    if (retryBtn) {

      retryBtn.addEventListener('click', reset);

    }

    function updateSelection(group, value) {

      section
        .querySelectorAll(`.hs-checker__option[data-group="${group}"]`)
        .forEach(option => {

          option.classList.toggle(
            'is-selected',
            option.dataset.value === value
          );

        });

    }

    function evaluate() {

      if (!state.skin || !state.hair) return;

      const compatible = isCompatible();

      renderResult(compatible);

    }

    function isCompatible() {

      if (state.skin === config.deepSkin) {
        return false;
      }

      if (
        config.incompatibleHair.includes(state.hair)
      ) {
        return false;
      }

      return true;

    }

    function renderResult(isCompatibleResult) {

        const right = section.querySelector('.hs-checker__right');

if (display) {
    display.classList.add('is-visible');
}

if (right) {
    right.classList.add('is-complete');
}

      

      if (result) {

        result.hidden = false;

        result.classList.remove('hs-checker__result--hidden');

        requestAnimationFrame(() => {

          result.classList.add('is-visible');

        });

      }

      if (isCompatibleResult) {

        if (resultIcon) {
          resultIcon.src = config.assets.successIcon || '';
        }

        if (resultTitle) {
          resultTitle.textContent =
            config.text.successTitle || '';
        }

        if (resultText) {
          resultText.innerHTML =
            config.text.successText || '';
        }

      } else {

        if (resultIcon) {
          resultIcon.src = config.assets.errorIcon || '';
        }

        if (resultTitle) {
          resultTitle.textContent =
            config.text.errorTitle || '';
        }

        if (resultText) {
          resultText.innerHTML =
            config.text.errorText || '';
        }

      }

      setTimeout(() => {

    display.scrollIntoView({

        behavior: "smooth",

        block: "nearest"

    });

}, 150);

    }

        function reset() {

      state.skin = null;
      state.hair = null;

      optionButtons.forEach(option => {
        option.classList.remove('is-selected');
      });

      if (result) {

        result.classList.remove('is-visible');

        result.classList.add('hs-checker__result--hidden');

        result.hidden = true;

      }

      if (display) {
  display.classList.remove('is-visible');
}

const right = section.querySelector('.hs-checker__right');

if (right) {
    right.classList.remove('is-complete');
}

      if (resultIcon) {
        resultIcon.removeAttribute('src');
      }

      if (resultTitle) {
        resultTitle.textContent = '';
      }

      if (resultText) {
        resultText.innerHTML = '';
      }

    }

  }

  function initAll() {

    document
      .querySelectorAll('.hs-compatibility')
      .forEach(initSection);

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAll);

  } else {

    initAll();

  }

  document.addEventListener('shopify:section:load', event => {

    const section = event.target.querySelector('.hs-compatibility');

    if (section) {
      initSection(section);
    }

  });

  document.addEventListener('shopify:section:select', event => {

    const section = event.target.querySelector('.hs-compatibility');

    if (section) {
      initSection(section);
    }

  });

})();